import { useInitAPI } from 'modules/auth/hooks/useInitAPI';
import { useInitAccount } from 'modules/account/hooks/useInitAccount';
import { useInitAccountStatus } from 'modules/accountStatus/hooks/useInitAccountStatus';
import { useInitUser } from 'modules/user/hooks/useInitUser';

export interface IAccountProviderProps {
  children: React.ReactNode;
}

export const AccountProvider = ({ children }: IAccountProviderProps) => {
  useInitAPI();

  useInitUser();

  useInitAccount();

  useInitAccountStatus();

  return <>{children}</>;
};
